import isLocalDomain from 'utils/isLocalDomain'
import isDevDomain from 'utils/isDevDomain'
import isLocalReCaptchaEnabled from 'utils/isLocalReCaptchaEnabled'

const isReCaptchaDisabled = (): boolean => {
  return (isLocalDomain() || isDevDomain()) && !isLocalReCaptchaEnabled()
}

export default isReCaptchaDisabled
